import {initializeConnector} from '@web3-react/core'
import {MetaMask} from '@web3-react/metamask'
import {WalletConnect} from '@web3-react/walletconnect'
import UAuth from '@uauth/js'
import {UAuthConnector} from '@uauth/web3-react'

UAuthConnector.registerUAuth(UAuth);

const metaMask = initializeConnector((actions) => new MetaMask({ actions }));

const walletConnect = initializeConnector(
  (actions) =>
    new WalletConnect({
      actions,
      options: {
        rpc: {1: `https://mainnet.infura.io/v3/b3aa0147f2614ce38cd33ac545149f06`},
        qrcode: true,
      },
    })
)
let redirUri;
if(window.location.hostname === "localhost" || "127.0.0.1"){
  redirUri = "https://landcoin.netlify.app/"
} else {
  redirUri = "https://landcoin.netlify.app/"
}
const uauthOptions = {
  clientID: "4e4c5e8d-4b47-4fae-b2d1-e9d1e964bdbb",
  redirectUri: redirUri,
  // Scope must include openid and wallet
  scope: 'openid wallet',

  // Injected/metamask and walletconnect connectors are required
  connectors: {injected: metaMask[0], walletconnect: walletConnect[0]}
}
const uauth = initializeConnector(
  (actions) => new UAuthConnector({
    actions,
    options: uauthOptions,
  })
)

const getMeData = async() => {
  const userData = await new UAuth(uauthOptions).user()
  console.log("===",userData.sub)
  localStorage.setItem('currentDomain', JSON.stringify(userData.sub))
  return userData.sub
}
console.log("+++",getMeData())


// const uauthvtwo = new UAuth({
//   options: {
//     // These values can be copied from your dashboard client configuration
//     clientID: "4e4c5e8d-4b47-4fae-b2d1-e9d1e964bdbb",
//     redirectUri: "http://localhost:3000",
//     // Scope must include openid and wallet
//     scope: 'openid wallet',

//     // Injected/metamask and walletconnect connectors are required
//     connectors: {injected: metaMask[0], walletconnect: walletConnect[0]}
//   }
// })

// uauthvtwo.user()
//   .then((user) => {
//     console.log("User Information", user)
//   })
//   .catch(() => {
//     console.log("user ako kwa server .. ooh ulimweka")
//   })


// cokomaster1187.wallet
const connectors = {
  "UAuth": uauth,
  "MetaMask": metaMask,
  "WalletConnect": walletConnect,
}

export default connectors 